<div
  class="rounded-[20px] text-xs flex justify-center items-center gap-1 font-medium px-3 py-2 border"
  #badgeRef
>
  <ng-content select="[icon]"></ng-content>
  {{ badgeText() }}
</div>
